import { render, staticRenderFns } from "./sidemenu.vue?vue&type=template&id=1eb296f2&scoped=true"
import script from "./sidemenu.vue?vue&type=script&lang=js"
export * from "./sidemenu.vue?vue&type=script&lang=js"
import style0 from "./sidemenu.vue?vue&type=style&index=0&id=1eb296f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb296f2",
  null
  
)

export default component.exports